<template>
    <section
        class="show-detail-one-week-stats"
        :class="{ 'stats-loading': !aggregate, 'premium-feature-content': !hasAggregate }"
    >
        <h4 v-if="aggregate">Show Stats</h4>
        <h5 v-if="aggregate">Since Opening Week</h5>
        <loading v-if="!aggregate"/>
        <div class="stats-grid" v-else>
            <div class="stats-type-label empty-cell"></div>
            <div class="stats-type-label">Gross</div>
            <div class="stats-type-label">Attendance</div>
            <div class="stats-type-label">Ticket Average</div>

            <template class="row" v-for="key in ['highest', 'lowest']">
                <div
                    :key="`${key}_label}`"
                    class="data stats-week-label"
                    :class="key"
                >{{ upperFirst(key) }} Week Ever</div>

                <div :key="`${key}_gross}`" class="data">
                    <p>{{ aggregate.gross[key].value / 100 | money }}</p>
                    <span
                        class="subtext"
                    >{{ aggregate.gross[key].week.start | date }} - {{ aggregate.gross[key].week.end | date }}</span>
                </div>

                <div :key="`${key}_attendance}`" class="data">
                    <p>{{ aggregate.attendance[key].value | commaNumber }}</p>
                    <span
                        class="subtext"
                    >{{ aggregate.attendance[key].week.start | date }} - {{ aggregate.attendance[key].week.end | date }}</span>
                </div>

                <div :key="`${key}_ticket_average}`" class="data">
                    <p>{{ aggregate.ticket_average[key].value / 100 | money }}</p>
                    <span
                        class="subtext"
                    >{{ aggregate.ticket_average[key].week.start | date }} - {{ aggregate.ticket_average[key].week.end | date }}</span>
                </div>
            </template>
        </div>

        <div class="premium-content-message" v-if="aggregate && !hasAggregate">
            <a
                href="#"
                class="button button-grey button-disabled"
                @click.prevent.stop
            >Historical Data for this Show Coming Soon</a>
        </div>
    </section>
</template>

<script>
import upperFirst from 'lodash/upperFirst';

export default {
    computed: {
        show() {
            return this.$store.getters['shows/show'](this.$route.params.show);
        },
        aggregate() {
            if (!this.show.id) {
                return false;
            }

            return this.$store.getters['shows/aggregate'](this.show.slug);
        },
        hasAggregate() {
            if (!this.show.id) {
                return false;
            }

            return this.$store.getters['shows/hasAggregate'](
                this.show.slug,
                'opening',
            );
        },
    },
    methods: {
        upperFirst,
    },
};
</script>
